import React from "react";
import { BulkMessagesTab } from "./BulkMessagesTab";
import { GamesLiveEventsTab } from "./GamesLiveEventsTab";
import { TableTabs } from "@/components/DataTable/TableTabs";
import { useTranslation } from "react-i18next";
import { OverviewDataCells } from "./OverviewDataCells";
import { GetStarted } from "@/components/GetStarted";
import { useOrg } from "@/hooks/useOrg";
import { RecentlyReachedCarousel } from "./RecentlyReachedCarousel";
import { PageTitle } from "@/components/PageTitle";
import { FeedPostsTab } from "./FeedPostsTab";

export const CommunityToolsOverview = () => {
  const { t } = useTranslation();
  const { org, loading: orgLoading, error: orgError } = useOrg();

  return (
    <div>
      <PageTitle title={t("nav.overview")} className="border-b" />
      <section className="flex flex-col gap-6 p-6">
        <GetStarted />

        <div className="flex gap-6">
          <section className="flex min-h-[136px] w-[264px] flex-col gap-4">
            <OverviewDataCells
              orgId={org?.id}
              orgIdLoading={orgLoading}
              orgIdError={orgError}
            />
          </section>
          <section className="w-full max-w-[calc(100%-264px)]">
            <RecentlyReachedCarousel />
          </section>
        </div>

        <section className="pt-2">
          <TableTabs
            activeTab={0}
            tabs={[
              {
                label: t(
                  "feedPost.communityToolsOverview.tabs.feedPost.tabName",
                ),
                children: <FeedPostsTab />,
              },
              {
                label: t(
                  "gamesLiveEvents.communityToolsOverview.tabs.gamesLiveEvents.tabName",
                ),
                children: <GamesLiveEventsTab />,
              },
              {
                label: t(
                  "bulkMessaging.communityToolsOverview.tabs.bulkMessages.tabName",
                ),
                children: <BulkMessagesTab />,
              },
            ]}
          />
        </section>
      </section>
    </div>
  );
};
